module.exports = __webpack_public_path__ + "static/img/watch-comics.ea2208f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/BoxingCamp/img/button-area/watch-comics.png
// module id = 481
// module chunks = 0